import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WorkspaceLayout } from '../../components/layout/WorkspaceLayout';
import { ProjectSkillsPanel } from '../../features/skills/ProjectSkillsPanel';
import { useAppDispatch, useAppSelector } from '../../hooks/useAppRedux';
import { useI18n } from '../../hooks/useI18n';
import { fetchProjectById, setSelectedProjectId } from '../../redux/slices/projectsSlice';

export const SkillsPage = () => {
  const { projectId = '' } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useI18n();
  const [status, setStatus] = useState('loading');
  const { items } = useAppSelector((state) => state.projects);
  const project = items.find((item) => item.id === projectId) || null;

  useEffect(() => {
    if (!projectId) {
      setStatus('not-found');
      return;
    }

    let cancelled = false;
    setStatus('loading');
    dispatch(setSelectedProjectId(projectId));

    dispatch(fetchProjectById(projectId))
      .unwrap()
      .then(() => {
        if (!cancelled) {
          setStatus('ready');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStatus('not-found');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [dispatch, projectId]);

  if (status === 'not-found' || (!project && status !== 'loading')) {
    return <div className="p-10 text-center text-lg">{t('projectNotFound')}</div>;
  }

  const layoutProject = project || { id: projectId, name: t('skillsTitle') };

  return (
    <WorkspaceLayout project={layoutProject} backTo={`/workspace/${projectId}`} activeSection="skills">
      {status === 'loading' ? (
        <div className="p-8 text-sm text-neutral-500">{t('skillsLoading')}</div>
      ) : (
        <ProjectSkillsPanel
          project={project}
          onActivateFeature={(featureKey) =>
            navigate(`/workspace/${projectId}`, { state: { activateFeature: featureKey } })
          }
        />
      )}
    </WorkspaceLayout>
  );
};
